export const VELOCITY_LOCAL_STORAGE_KEY = 'velocity';

/**
 * The key used to store the user's favorite items in the local storage.
 */
export const FAVORITES_LOCAL_STORAGE_KEY = 'favorites';

export const LOYALTY_LOCAL_STORAGE_KEY = 'loyalty';

/**
 * Cross-tab throttle state for re-minting Auth0 tokens whose claims are still stale.
 */
export const AUTH0_CLAIM_REFRESH_STORAGE_KEY = 'auth0ClaimRefresh';

/**
 * Monotonic generation bumped on voluntary Auth0 logout so other tabs can drop
 * an in-flight access-token write. Not a probe skip: a later document load does
 * not treat a stable value as logged-out.
 */
export const AUTH0_LOGOUT_GENERATION_STORAGE_KEY = 'auth0LogoutGeneration';

export const MERGED_CART_LOCAL_STORAGE_KEY = 'dismissedMergedCartBanners';

export const PROCEED_TO_CHECKOUT_PRESSED = 'proceedToCheckoutPressed';

export const AUTH0_CART_MERGE_COMPLETED_KEY = 'auth0CartMergeCompleted';

export const AUTH0_RETURN_TO_SESSION_KEY = 'auth0ReturnTo';

export const AUTH0_FLOW_ENTRY_SESSION_KEY = 'auth0FlowEntry';

export const AUTH0_FLOW_RESTORE_SESSION_KEY = 'auth0FlowRestore';

export const AUTH0_LOGIN_METHOD_SESSION_KEY = 'auth0LoginMethod';

export const AUTH0_LOGIN_COMPLETED_SESSION_KEY = 'auth0LoginCompleted';

export const AUTH0_AUTOSHIP_ENROLL_SESSION_KEY = 'auth0InStoreAutoshipAnalytics';

export const CART_NOTIFICATIONS_STORAGE_KEY = 'cartNotificationsStorageKey';

export const CART_NOTIFICATIONS_SEEN_IDS_KEY = 'cartNotificationsSeenIds';

export const AUTOSHIP_CACHE_KEY = 'autoship_data_cache';

export const PDP_FINDING_METHOD_BY_SKU = 'pdpFindingMethodBySku';

export const CHATBOT_CACHE_KEY = 'x-petm-chatbot-cache';
